import { postData } from "../../components/FetchServices";
import { isAlphigaEnabledCompany } from "../constants/alphigaCompanies";
import { setServeFirstBrandingHidden } from "../../helpers/serveFirstBranding";

export const getDetails = async (location, forEmp) => {
  const body = {
    location: location,
    main_location:
      forEmp === "forEmp" ? location : localStorage.getItem("location_id"),
    api_version: "v2",
    source: "web",
  };
  const result = await postData("api/getAllData", body);
  if (result?.status === 200) {
    localStorage.setItem("showGoogle", result?.data?.showGoogleQr || false);
    localStorage.setItem("googleLink", result?.data?.googleReviewUrl || "");
    setServeFirstBrandingHidden(result?.data?.hideServeFirst);
    const data = result?.data;
    const resolvedCompanyId = String(
      data?.company_id ?? localStorage.getItem("company_id") ?? "",
    ).trim();
    return {
      ...data,
      company_id: resolvedCompanyId,
      is_alphiga: isAlphigaEnabledCompany(resolvedCompanyId),
    };
  } else {
    localStorage.setItem("location_id", "");
  }
};
